<template>
  <div class="mt-5">
       <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">
            <tab-content title="Step 1" class="mb-5">
                <!-- tab 1 content -->
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input label="Device Model" disabled v-model="configuration.device_model" class="w-full" />
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-input maxlength="99" label="Device Name" v-model="configuration.device_name" class="w-full" />
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-select  class="w-full select-large" label="Refresh Rate" v-model="configuration.refresh_rate">
                            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in refresh_rates" class="w-full" />
                        </vs-select>
                    </div>
                </div>
            </tab-content>

            <!-- Ambient Content -->
            <tab-content class="mb-5" title="Ambient">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-3">
                        <vs-select  class="w-full select-large" label="Sensor Type" :value="configuration.ambient_sensor.sensor_type" v-model="configuration.ambient_sensor.sensor_type.name" disabled>
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input maxlength="99" label="Sensor Name"  v-model="configuration.ambient_sensor.name" class="w-full mt-4" />
                    </div>
                </div>
                <div style="margin-top:20px">
                    <vs-checkbox v-model="configuration.ambient_sensor.limits_enabled">Warning Limits</vs-checkbox>
                </div>
                <div :key="parameterIndex" v-for="(parameter, parameterIndex) in configuration.ambient_sensor.sensor_type.parameters">
                    <div style="text-align:center; padding:10px">
                            {{ parameter.name }}
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.lower_value }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12">
                            <vs-slider :disabled="!configuration.ambient_sensor.limits_enabled" :max="parameter.maximum" :min="parameter.minimum" ticks :step="parameter.step" v-model="parameter.slider" @change="updateSlider($event, parameter)" color="danger"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.upper_value }}</label>
                        </vs-col>
                    </vs-row>
                </div>
            </tab-content>

            <!-- Sensor 1 Content -->
            <tab-content class="mb-5" title="Sensor 1">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-3">
                        <vs-select class="w-full select-large" label="Sensor Type" @input="sensor1TypeChanged" v-model="configuration.sensor_1.sensor_type.name">
                            <vs-select-item :hidden="item.name == 'Ambient'" :key="index" :value="item.name" :text="item.name"
                            v-for="(item, index) in configuration.sensors_available"
                            class="w-full"/>
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input maxlength="99" label="Sensor Name"  v-model="configuration.sensor_1.name" class="w-full mt-4" />
                    </div>
                </div>
                <div style="margin-top:20px">
                    <vs-checkbox v-model="configuration.sensor_1.limits_enabled">Warning Limits</vs-checkbox>
                </div>
                <div :key="parameterIndex" v-for="(parameter, parameterIndex) in configuration.sensor_1.sensor_type.parameters">
                    <div style="text-align:center; padding:10px" v-if="!configuration.sensor_1.sensor_type.is_boolean">
                            {{ parameter.name }}
                    </div>
                    <div style="text-align:center; padding:10px" v-if="configuration.sensor_1.sensor_type.is_boolean">
                            Warn me when
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.lower_value }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="!configuration.sensor_1.sensor_type.is_boolean">
                            <vs-slider :disabled="!configuration.sensor_1.limits_enabled" :max="parameter.maximum" :min="parameter.minimum" ticks :step="parameter.step" v-model="parameter.slider" @change="updateSlider($event, parameter)" color="danger"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="configuration.sensor_1.sensor_type.is_boolean">
                            <vs-slider style="min-width:100%;" :max="1" :disabled="!configuration.sensor_1.limits_enabled" v-model="parameter.slider"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.upper_value }}</label>
                        </vs-col>
                    </vs-row>
                </div>
            </tab-content>

            <!-- Sensor 2 Content -->
            <tab-content class="mb-5" title="Sensor 2">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-3">
                        <vs-select  class="w-full select-large" label="Sensor Type" @input="sensor2TypeChanged" v-model="configuration.sensor_2.sensor_type.name">
                            <vs-select-item :hidden="item.name == 'Ambient'" :key="index" :value="item.name" :text="item.name" v-for="(item, index) in configuration.sensors_available" class="w-full" />
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input maxlength="99" label="Sensor Name"  v-model="configuration.sensor_2.name" class="w-full mt-4" />
                    </div>
                </div>
                <div style="margin-top:20px">
                    <vs-checkbox v-model="configuration.sensor_2.limits_enabled">Warning Limits</vs-checkbox>
                </div>
                <div :key="parameterIndex" v-for="(parameter, parameterIndex) in configuration.sensor_2.sensor_type.parameters">
                    <div style="text-align:center; padding:10px" v-if="!configuration.sensor_2.sensor_type.is_boolean">
                        {{ parameter.name }}
                    </div>
                    <div style="text-align:center; padding:10px" v-if="configuration.sensor_2.sensor_type.is_boolean">
                        Warn me when
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.lower_value }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="!configuration.sensor_2.sensor_type.is_boolean">
                            <vs-slider :disabled="!configuration.sensor_2.limits_enabled" :max="parameter.maximum" :min="parameter.minimum" ticks :step="parameter.step" v-model="parameter.slider" @change="updateSlider($event, parameter)" color="danger"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="configuration.sensor_2.sensor_type.is_boolean">
                            <vs-slider :max="1" style="min-width:100%;" :disabled="!configuration.sensor_2.limits_enabled" v-model="parameter.slider"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.upper_value }}</label>
                        </vs-col>
                    </vs-row>
                </div>
            </tab-content>

            <!-- Sensor 3 Content -->
            <tab-content class="mb-5" title="Sensor 3">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-3">
                        <vs-select  class="w-full select-large" label="Sensor Type" @input="sensor3TypeChanged" v-model="configuration.sensor_3.sensor_type.name">
                            <vs-select-item :hidden="item.name == 'Ambient'" :key="index" :value="item.name" :text="item.name" v-for="(item, index) in configuration.sensors_available" class="w-full" />
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input maxlength="99" label="Sensor Name"  v-model="configuration.sensor_3.name" class="w-full mt-4" />
                    </div>
                </div>
                <div style="margin-top:20px">
                    <vs-checkbox v-model="configuration.sensor_3.limits_enabled">Warning Limits</vs-checkbox>
                </div>
                <div :key="parameterIndex" v-for="(parameter, parameterIndex) in configuration.sensor_3.sensor_type.parameters">
                    <div style="text-align:center; padding:10px"  v-if="!configuration.sensor_3.sensor_type.is_boolean">
                        {{ parameter.name }}
                    </div>
                    <div style="text-align:center; padding:10px" v-if="configuration.sensor_3.sensor_type.is_boolean">
                        Warn me when
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.lower_value }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="!configuration.sensor_3.sensor_type.is_boolean">
                            <vs-slider :disabled="!configuration.sensor_3.limits_enabled" :max="parameter.maximum" :min="parameter.minimum" ticks :step="parameter.step" v-model="parameter.slider" @change="updateSlider($event, parameter)" color="danger"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="configuration.sensor_3.sensor_type.is_boolean">
                            <vs-slider :max="1" style="min-width:100%;" :disabled="!configuration.sensor_3.limits_enabled" v-model="parameter.slider"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.upper_value }}</label>
                        </vs-col>
                    </vs-row>
                </div>
            </tab-content>

            <!-- Sensor 4 Content -->
            <tab-content class="mb-5" title="Sensor 4">
                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-3">
                        <vs-select  class="w-full select-large" label="Sensor Type" @input="sensor4TypeChanged" v-model="configuration.sensor_4.sensor_type.name">
                            <vs-select-item :hidden="item.name == 'Ambient'" :key="index" :value="item.name" :text="item.name" v-for="(item, index) in configuration.sensors_available" class="w-full" />
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input maxlength="99" label="Sensor Name"  v-model="configuration.sensor_4.name" class="w-full mt-4" />
                    </div>
                </div>
                <div style="margin-top:20px">
                    <vs-checkbox v-model="configuration.sensor_4.limits_enabled">Warning Limits</vs-checkbox>
                </div>
                <div :key="parameterIndex" v-for="(parameter, parameterIndex) in configuration.sensor_4.sensor_type.parameters">
                    <div style="text-align:center; padding:10px" v-if="!configuration.sensor_4.sensor_type.is_boolean">
                        {{ parameter.name }}
                    </div>
                    <div style="text-align:center; padding:10px" v-if="configuration.sensor_4.sensor_type.is_boolean">
                        Warn me when
                    </div>
                    <vs-row vs-type="flex" vs-justify="center">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.lower_value }}</label>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="!configuration.sensor_4.sensor_type.is_boolean">
                            <vs-slider :disabled="!configuration.sensor_4.limits_enabled" :max="parameter.maximum" :min="parameter.minimum" ticks :step="parameter.step" v-model="parameter.slider" @change="updateSlider($event, parameter)" color="danger"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="8" vs-xs="12" v-if="configuration.sensor_4.sensor_type.is_boolean">
                            <vs-slider :max="1" style="min-width:100%;" :disabled="!configuration.sensor_4.limits_enabled" v-model="parameter.slider"/>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12">
                            <label>{{ parameter.upper_value }}</label>
                        </vs-col>
                    </vs-row>
                </div>
            </tab-content>

            <!-- Control step -->
            <tab-content title=" Control" class="mb-5">
                <div class="vx-row" v-if="!submitInProgress">
                    <div  class="vx-col w-full mt-5">
                        Remote Control Configuration
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-select class="w-full select-large" label="Manufacturer" @input="manufacturerChanged" v-model="configuration.control.installedController.manufacturer_model.manufacturer.id">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in configuration.control.manufacturers" class="w-full" />
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mt-5">
                        <vs-select class="w-full select-large" label="Types" @input="deviceTypeChanged" v-model="configuration.control.installedController.manufacturer_model.manufacturer_type.id">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in configuration.control.device_types" class="w-full" />
                        </vs-select>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mt-5">
                        <vs-select class="w-full select-large" label="Model" v-model="configuration.control.installedController.manufacturer_model.id">
                            <vs-select-item :key="index" :value="item.id" :text="item.model_code" v-for="(item,index) in configuration.control.models" class="w-full" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row" v-if="submitInProgress">
                    <vs-progress :height="12" :percent="submitInProgressPrecentage" color="warning"></vs-progress>
                    <div style="text-align:center; padding:10px">
                            {{ submitInProgressPrecentage }}
                    </div>
                </div>
            </tab-content>

        </form-wizard>
  </div>
</template>
<script>

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { sendRequest } from "../utils/requestHelpers"
import { getDeviceTypes, getConfiguration,
        getControlledDevice, getManufacturers,
        getModels, getParameters } from "../utils/setConfigurationHelpers"

import axios from "axios";
import store from "../store/store";

export default {
    data() {
        return {
            submitInProgress: false,
            submitInProgressPrecentage: 0,
            configuration: {
                device_status: "",
                device_model: "",
                device_name: "",
                refresh_rate: 0,
                ambient_sensor: {
                    name: "",
                    limits_enabled: false,
                    sensor_type: {
                        name: "",
                        is_boolean: false,
                        index: 1,
                        parameters: []
                    },
                },
                sensor_1: {
                    name: "",
                    limits_enabled: false,
                    sensor_type: {
                        name: "",
                        is_boolean: false,
                        index: 1,
                        parameters: []
                    },
                },
                sensor_2: {
                    name: "",
                    limits_enabled: false,
                    sensor_type: {
                        name: "",
                        is_boolean: false,
                        index: 1,
                        parameters: []
                    },
                },
                sensor_3: {
                    name: "",
                    limits_enabled: false,
                    sensor_type: {
                        name: "",
                        is_boolean: false,
                        index: 1,
                        parameters: []
                    },
                },
                sensor_4: {
                    name: "",
                    limits_enabled: false,
                    sensor_type: {
                        name: "",
                        is_boolean: false,
                        index: 1,
                        parameters: []
                    },
                },
                sensors_available: [],
                control: {
                    manufacturers: [],
                    device_types: [],
                    models: [],
                    installedController: {
                        manufacturer_model: {
                            manufacturer_type: {},
                            manufacturer: {},
                        },
                    },
                },
            },
            refresh_rates: [],
            device: this.$store.getters.getSelectedDevice,
        }
    },
    methods: {
        updateSlider(sliderValue, parameter) {
            parameter.slider = sliderValue;
            parameter.upper_value = sliderValue[1];
            parameter.lower_value = sliderValue[0];
        },
        sensorTypeChange(changedType, sensorConfig) {
            sensorConfig.limits_enabled = false;
            this.configuration.sensors_available.forEach(function(sensorType){
                if (changedType == sensorType.name){
                    sensorConfig.sensor_type = sensorType;
                    return;
                }
            });
            getParameters(sensorConfig, false).then(sensorType => {
                sensorConfig.sensor_type = JSON.parse(JSON.stringify(sensorType));
            });
        },
        sensor1TypeChanged(changedType) {
            this.sensorTypeChange(changedType, this.configuration.sensor_1);
        },
        sensor2TypeChanged(changedType) {
            this.sensorTypeChange(changedType, this.configuration.sensor_2);
        },
        sensor3TypeChanged(changedType) {
            this.sensorTypeChange(changedType, this.configuration.sensor_3);
        },
        sensor4TypeChanged(changedType) {
            this.sensorTypeChange(changedType, this.configuration.sensor_4);
        },
        manufacturerChanged(changedManufacturer) {
            var config = this.configuration;
            getModels(
                config,
                changedManufacturer,
                this.configuration.control.installedController.manufacturer_model.manufacturer_type.id,
                true
            );
        },
        deviceTypeChanged(changedDeviceType) {
            getModels(
                this.configuration,
                this.configuration.control.installedController.manufacturer_model.manufacturer.id,
                changedDeviceType, true);
        },
        formSubmitted() {
            this.submitInProgressPrecentage = 0;
            this.submitInProgress = true;
            let deviceConfiguration = {
                device_name: this.configuration.device_name,
                refresh_rate: this.configuration.refresh_rate,
                ambient_sensor: {
                    name: this.configuration.ambient_sensor.name,
                    type_index: this.configuration.ambient_sensor.sensor_type.index,
                    limits_enabled: this.configuration.ambient_sensor.limits_enabled? 1:0,
                    limit_1_lower: this.configuration.ambient_sensor.sensor_type.parameters[0].lower_value,
                    limit_1_upper: this.configuration.ambient_sensor.sensor_type.parameters[0].upper_value,
                    limit_2_lower: this.configuration.ambient_sensor.sensor_type.parameters[1].lower_value,
                    limit_2_upper: this.configuration.ambient_sensor.sensor_type.parameters[1].upper_value,
                    limit_3_lower: this.configuration.ambient_sensor.sensor_type.parameters[2].lower_value,
                    limit_3_upper: this.configuration.ambient_sensor.sensor_type.parameters[2].upper_value,
                    limit_4_normal_state: 0
                },
            };
            for (let index = 0; index < 4; index++) {
                deviceConfiguration['sensor_' + (index + 1)] = {
                    name: this.configuration['sensor_' + (index + 1)].name,
                    type_index: this.configuration['sensor_' + (index + 1)].sensor_type.index,
                    limits_enabled: this.configuration['sensor_' + (index + 1)].limits_enabled? 1:0,
                };
                if (this.configuration['sensor_' + (index + 1)].sensor_type.parameters != null) {
                    let sensorParameters = this.configuration['sensor_' + (index + 1)].sensor_type.parameters;
                    if (this.configuration['sensor_' + (index + 1)].sensor_type.is_boolean){
                        deviceConfiguration['sensor_' + (index + 1)]["limit_4_normal_state"] = sensorParameters[0].slider? 0:1;

                    } else {
                        for (let index2 = 0; index2 < sensorParameters.length; index2++) {
                            const sensorParameter = sensorParameters[index2];
                            deviceConfiguration['sensor_' + (index + 1)]["limit_" + (sensorParameter.order_in_sensor + 1) + "_lower"] = sensorParameter.lower_value;
                            deviceConfiguration['sensor_' + (index + 1)]["limit_" + (sensorParameter.order_in_sensor + 1) + "_upper"] = sensorParameter.upper_value;
                        }
                    }
                }
            }
            let deviceManufacturer = {
                "manufacturer_model": this.configuration.control.installedController.manufacturer_model.id
            };
            var successCallback = () => {
                this.$vs.notify({
                title: 'Success',
                position: 'top-right',
                text: 'Device Configration Updated successfully.',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'});
                this.$router.push('/device-manager');
            };
            var errorCallback = () => {
                this.$vs.notify({
                title: 'Error',
                position: 'top-right',
                text: 'Something wrong',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'});
            };
            var url = process.env.VUE_APP_API + 'devices/' + this.device.serial_number + '/configurations/';
            var extraParams = {
                headers: {
                    Authorization: "JWT " + store.getters.getToken
                },
                onUploadProgress: function( progressEvent ) {
                    this.submitInProgressPrecentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                }.bind(this)
            };

            axios.post(url, deviceConfiguration, extraParams).then(() => {
                sendRequest("post", "devices/" + this.device.serial_number + "/controlled-devices/" , deviceManufacturer, successCallback, errorCallback, this);
            })
            .catch(() =>{
                this.$vs.notify({
                    title: 'Error',
                    position: 'top-right',
                    text: 'Error in set configuration, please try again later',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'});
                this.submitInProgress = false;
            });
        },
        checkDeviceStatus(){
            var successCallback = (response) => {
                if(response.data[0].event_type == 'disconnected'){
                    this.$router.push('/device-manager');
                }
            };
            sendRequest('get', 'devices/' + this.device.serial_number + '/status/?limit=1', null, successCallback, null, this);      
        }
    },
    components: {
        FormWizard,
        TabContent
    },
    created() {
        this.checkDeviceStatus();
        for(var i = 1; i <= 60; i++){
            this.refresh_rates.push(i);
        }
        getConfiguration(this.device.serial_number, this.configuration);
        getControlledDevice(this.device.serial_number, this.configuration);
        getManufacturers(this.configuration);
        getDeviceTypes(this.configuration);
    }
}
</script>
